<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>题库管理</el-breadcrumb-item>
      <el-breadcrumb-item>分类管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">分类管理</span>
        <el-button icon="el-icon-plus" style="float:right;" type="primary" size="normal" @click="handleAdd">添加分类</el-button>
      </div>

      <!-- 数据表格 -->
      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column type="index" label="#" width="60"></el-table-column>
        <el-table-column prop="name" label="分类名称" min-width="200"></el-table-column>
        <el-table-column prop="sort" label="排序" width="100"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="180">
          <template slot-scope="scope">{{ scope.row.createDate | dateFormat }}</template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 添加/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
      @closed="resetForm">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" :max="9999" controls-position="right" style="width: 100%"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleSubmit">{{ submitting ? '提交中...' : '确定' }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CategoryList',
  data () {
    return {
      // 分类列表数据
      list: [],
      // 加载状态
      loading: false,
      // 对话框可见性
      dialogVisible: false,
      // 是否为编辑模式
      isEdit: false,
      // 当前编辑的分类ID
      currentId: '',
      // 提交中状态
      submitting: false,
      // 表单数据
      form: {
        name: '',
        sort: 0
      },
      // 表单验证规则
      rules: {
        name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogTitle () {
      return this.isEdit ? '编辑分类' : '添加分类'
    }
  },
  created () {
    this.getList()
  },
  methods: {
    // 获取分类列表
    async getList () {
      this.loading = true
      try {
        const { data: res } = await this.$http.get('tiku/category/list')
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.list = res.data.list
      } catch (error) {
        this.$message.error('获取分类列表失败')
      } finally {
        this.loading = false
      }
    },

    // 点击添加按钮
    handleAdd () {
      this.isEdit = false
      this.currentId = ''
      this.dialogVisible = true
    },

    // 点击编辑按钮
    handleEdit (row) {
      this.isEdit = true
      this.currentId = row._id
      this.form.name = row.name
      this.form.sort = row.sort
      this.dialogVisible = true
    },

    // 提交表单
    async handleSubmit () {
      const valid = await this.$refs.formRef.validate().catch(() => false)
      if (!valid) return

      this.submitting = true
      try {
        let res
        if (this.isEdit) {
          res = await this.$http.put(`tiku/category/modify/${this.currentId}`, this.form)
        } else {
          res = await this.$http.post('tiku/category/add', this.form)
        }

        if (res.data.meta.status !== 200) {
          return this.$message.error(res.data.meta.msg)
        }

        this.$message.success(this.isEdit ? '修改成功' : '添加成功')
        this.dialogVisible = false
        this.getList()
      } catch (error) {
        this.$message.error('操作失败')
      } finally {
        this.submitting = false
      }
    },

    // 点击删除按钮
    async handleDelete (row) {
      const confirmResult = await this.$confirm(
        `确定要删除分类「${row.name}」吗？`,
        '确认删除',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(() => {})

      if (confirmResult !== 'confirm') return this.$message.info('操作已取消')

      try {
        const { data: res } = await this.$http.delete(`tiku/category/remove/${row._id}`)
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success('删除成功')
        this.getList()
      } catch (error) {
        this.$message.error('删除操作失败')
      }
    },

    // 重置表单
    resetForm () {
      this.form = {
        name: '',
        sort: 0
      }
      this.$refs.formRef && this.$refs.formRef.resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
</style>
